export default {
  en: {
    back: 'Back',
    backToSpecialOfferList: 'Back to special offer list',
    previewSpecialOffer: 'Preview Special Offer',
    saveDraft: 'Save Draft',
    saveSpecialOffer: 'Save Special Offer',
    updateSpecialOfferSuccessTitle: 'Success',
    updateSpecialOfferSuccessMessage: 'Update Special Offer Success.'
  },
  th: {
    back: 'กลับ',
    backToSpecialOfferList: 'กลับไปหน้ารายการข้อเสนอพิเศษ',
    previewSpecialOffer: 'ดูตัวอย่างข้อเสนอพิเศษ',
    saveDraft: 'บันทึกฉบับร่าง',
    saveSpecialOffer: 'บันทึกข้อเสนอพิเศษ',
    updateSpecialOfferSuccessTitle: 'สำเร็จ',
    updateSpecialOfferSuccessMessage: 'แก้ไขข้อเสนอพิเศษสำเร็จ.'
  }
}
